export enum Duration {
  HOURS = 'Hours',
  DAYS = 'Days',
  BUSINESS_DAYS = 'Business Days',
  WEEKS = 'Weeks'
}
